var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(-0.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.333)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M104.962,156.694a2.764,2.764,0,0,1-1.481-.878,10.512,10.512,0,0,1-1.866-2.958,9.851,9.851,0,0,1-.8-3.888,5.566,5.566,0,0,1,.689-2.759,4.062,4.062,0,0,1,2.683-2.022,2.758,2.758,0,0,1,1.429-.016c.473.14.939.305,1.4.473a1.571,1.571,0,0,0,1.219.068c.277-.12.566-.215.85-.319a4.568,4.568,0,0,1,1.436-.345,4.134,4.134,0,0,1,2.651.789,3.425,3.425,0,0,1,.825.87c-.031.024-.055.043-.08.06a4.276,4.276,0,0,0-.9.829,3.546,3.546,0,0,0-.767,2.892,3.486,3.486,0,0,0,.964,1.942,5.02,5.02,0,0,0,1.279.884c-.073.172-.215.449-.284.623a9.559,9.559,0,0,1-1.159,2.07,5.92,5.92,0,0,1-1.12,1.266,1.99,1.99,0,0,1-1.4.447,3.232,3.232,0,0,1-1.138-.321,3.277,3.277,0,0,0-2.433-.178c-.208.065-.4.167-.611.234A5.443,5.443,0,0,1,104.962,156.694Z",
    transform: "translate(-100.813 -140)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    transform: "translate(6.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M251.774,55.888a5.536,5.536,0,0,1-.012.8,3.68,3.68,0,0,1-1.362,2.378,2.771,2.771,0,0,1-1.957.677,2.364,2.364,0,0,1,.029-.862,3.74,3.74,0,0,1,1.624-2.388,3.564,3.564,0,0,1,1.468-.577C251.591,55.908,251.73,55.888,251.774,55.888Z",
    transform: "translate(-248.417 -55.888)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/AppleLogo.b9f9e8e9.svg";
export { ForwardRef as ReactComponent };